// src/features/reports/components/Reports/components/BookingCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../Reports.module.css';
import { formatNumber } from '../../../../../shared/utils/formatters';
import { TYPE_MAP, STATUS_MAP } from '../hooks/useReportsData';

export default function BookingCard({ booking }) {
  const st        = STATUS_MAP[booking.status] || { label: booking.status, cls: 'sPending' };
  const remaining = parseFloat(booking.remaining_amount || 0);

  return (
    <Link to={`/booking/${booking.id}`} className={styles.bCard}>
      <div className={styles.bCardTop}>
        <div>
          <p className={styles.bName}>{booking.client?.name || '—'}</p>
          <p className={styles.bType}>
            {TYPE_MAP[booking.booking_type] || booking.booking_type}
          </p>
        </div>
        <span className={`${styles.sBadge} ${styles[st.cls]}`}>{st.label}</span>
      </div>

      <p className={styles.bDate}>{booking.booking_date}</p>

      <div className={styles.bFinRow}>
        <div className={styles.bFinCell}>
          <span className={styles.bFinLbl}>إجمالي</span>
          <span className={styles.bFinVal}>
            {formatNumber(booking.total_price, 0)}
          </span>
        </div>
        <div className={styles.bFinCell}>
          <span className={styles.bFinLbl}>مدفوع</span>
          <span className={`${styles.bFinVal} ${styles.bPaid}`}>
            {formatNumber(booking.total_paid, 0)}
          </span>
        </div>
        <div className={styles.bFinCell}>
          <span className={styles.bFinLbl}>متبقي</span>
          <span className={`${styles.bFinVal} ${remaining > 0 ? styles.bRem : ''}`}>
            {formatNumber(remaining, 0)}
          </span>
        </div>
      </div>
    </Link>
  );
}